import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./LoginPage.css";

function LoginPage() {
  const [mobile, setMobile] = useState("");
  const [pin, setPin] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/";

  const handleLogin = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("pin", pin);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/loginRegister.php`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );

      const data = await res.json();

      if (data.success) {
        navigate(redirectTo);
      } else {
        setMessage(data.message);
      }
    } catch (err) {
      setMessage("Server error");
    }
  };

  return (
    <div className="container text-center" style={{ marginTop: "50px" }}>
      <form onSubmit={handleLogin}>
        {/* Mobile Input */}
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="text-center me-2 mt-4">
            <div style={{ fontWeight: "bold" }}>
              ENTER YOUR <br></br>MOBILE NUMBER
            </div>
            <div>
              <img src="/images/speaker.webp" alt="Speaker" width="30" />
            </div>
          </div>

          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
            required
            minLength="7"
            maxLength="15"
            inputMode="numeric"
            style={{
              width: "180px",
              height: "40px",
              fontWeight: "bold",
              border: "2px solid black",
              marginRight: "10px",
              marginLeft: "0px",
            }}
          />

          <img src="/images/mobile.jpg" alt="Phone" width="60" />
        </div>

        {/* PIN Input */}
        <div className="d-flex align-items-center justify-content-center">
          <div className="text-center">
            <div style={{ fontWeight: "bold" }}>
              ENTER ANY <br></br>4 DIGIT PIN
            </div>
            <div>
              <img src="/images/speaker.webp" alt="Speaker" width="30" />
            </div>
          </div>

          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            required
            minLength="4"
            maxLength="4" // 4 digit PIN
            inputMode="numeric"
            className="password-box-input"
            style={{
              width: "180px",
              height: "40px",
              fontWeight: "bold",
              border: "2px solid black",
              marginRight: "10px",
              marginLeft: "26px",
            }}
          />

          <img src="/images/key.jpg" alt="Key" width="60" />
        </div>
                      {message && <p className="text-danger" style={{marginLeft:"25px",fontWeight:"bold"}}>{message}</p>}
        {/* Submit Button */}
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ marginLeft: "60px" }}
        >
          {/* Message */}

          <button type="submit" style={{ border: "none", background: "none" }}>
            <img src="/images/ok.jpg" alt="OK" width="100" />
          </button>

          <img src="/images/speaker.webp" alt="Speaker" width="30" />
        </div>
      </form>
    </div>
  );
}

export default LoginPage;
